import React from 'react'
import { classNames } from '../../../utils'

/**
 * BUTTON EFFECT IN FORM ELEMENT
 * @param {{ type?: 'submit' | 'reset', label?: string, disabled?: boolean }} props 
 * @returns {JSX.Element}
 */
function FormBtn({ label = 'Enregistrer', type = 'submit', disabled = false, className = '' }) {
  return (
    <button disabled={disabled} type={type} className={classNames(`btn py-3 uppercase tracking-wide font-medium text-sm transition-colors hover:border-none disabled:text-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed ${className}`, type === 'submit' ? 'text-white bg-teal-700 hover:bg-teal-800' : 'text-gray-500 bg-gray-200 hover:bg-gray-300')}>
      {label}
    </button>
  )
}

export default FormBtn